import { erpAxios } from '.';

const insertIbsPustanjaKreditaAnalitika = async (data) => {
  const res = await erpAxios.post(`/ibsPustanjaKreditaAnalitika/add`, data);
  return res;
};

export default insertIbsPustanjaKreditaAnalitika;
